// extracted by mini-css-extract-plugin
export default {"installationDirections":"Install_installationDirections__2H0vm","header":"Install_header__ky0kn"};